import styled from "styled-components";

export const ContainerLoading = styled.div`
    flex: auto;
    display: flex;
    align-items: center;
    justify-content: center;
`;


export const Container = styled.div`
    margin-left: 5rem;
    margin-right: 1rem;
`;


export const Content = styled.div`
    margin-bottom: 2.5rem;
    overflow: scroll;
    scroll-behavior: auto;

    &::-webkit-scrollbar-track {
        background-color: #FFF;
    }

    &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
    }

    &::-webkit-scrollbar-thumb {
        background: #C3C3C3;
        border-radius: 4px;
    }

    scrollbar-width: thin;
    scrollbar-color: #C3C3C3;
    scrollbar-track-color: #FFF;  
`;

export const Table = styled.table`
    width: 100%;
    font-size: 0.9rem;
    margin: 25px 0;
    color: var(--colorFontsCardsDashboard);


    thead{
        tr{
            background: var(--colorBackgroundCardsDashboard);

          
            th{
                font-size: 17px;
                text-align: right;
         

                @media(max-width: 800px){
                    font-size: 15px;
                }

                @media(max-width: 700px){
                    font-size: 13px;
                }
            }

            th:first-child{
                text-align: center;
            }

            th:nth-child(2),th:nth-child(3){
                text-align: left;
            }

            .header-fixed{
                position: sticky;
                top: 0;
                left: 0;
                background: var(--colorBackgroundCardsDashboard);
            }
        }
    }

    tbody{
        tr{
            border-bottom: 1px solid #DDD;
            position: relative;
            background: #fff;

            &:nth-child(even){
                background: #f2f2f2;
            }

            td:first-child{
                text-align: center;
            }

            td:nth-child(2),td:nth-child(3){
                text-align: left;
            }

            td{
                text-align: right;
            }

            .body-fixed{
                position: sticky;
                left: 0;
                background: inherit;
            }

        }
    }

    th, td{
        padding: 0.15rem 0.35rem;
        font-size: 15px;
        height: 40px;

        @media(max-width: 800px){
            font-size: 13px;
        }

        @media(max-width: 700px){
            font-size: 12px;
        }
    }
`;

export const Button = styled.div`
    padding: 0.5rem;
    border-radius: 5px;
    background: #2e9699;
    color: #FFF;
    margin: 1rem auto;
    max-width: 300px;
    cursor: pointer;
    opacity: ${props => props.loadingButton ? 0.5 : 1};
    pointer-events: ${props => props.loadingButton ? 'none' : 'all'};
    text-align: center;
`;